<template>
  <div>
    <b-list-group>
      <b-row>
        <div v-for="subCategory in subCategories" :key="subCategory._id" class="col-12 col-md-6 mb-4">
          <b-list-group-item
            :class="['sub-category-list-item', `${selectedSubCategories.includes(subCategory._id) ? 'selected' : ''}`]"
            @click="selectSubCategory(subCategory._id)"
            >{{ subCategory.title }}</b-list-group-item
          >
        </div>
      </b-row>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: {
    subCategories: { type: Array, required: true },
    preSelection: { type: Array }
  },
  data() {
    return {
      selectedSubCategories: []
    }
  },
  methods: {
    selectSubCategory(_id) {
      if (this.selectedSubCategories.includes(_id)) {
        this.selectedSubCategories = this.selectedSubCategories.filter(id => id !== _id)
      } else {
        this.selectedSubCategories.push(_id)
      }
      this.$emit('new-selected-sub-categories', this.selectedSubCategories)
    }
  },
  mounted() {
    if (this.preSelection.length > 0) {
      this.selectedSubCategories = [...this.preSelection]
    }
  }
}
</script>

<style scoped>
.sub-category-list-item {
  height: 80px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px 48px;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  color: #00903c;
  cursor: pointer;
  font-weight: 700;
  font-size: 20px;
}
.sub-category-list-item.selected {
  background-color: #00903c;
  color: #fff;
}
</style>
